import React, { useEffect, useState } from 'react';
import LoadingPage from '../Loading/loading';
import { proxy } from '../../config';
import './form.css'
import { useNavigate, useParams } from 'react-router-dom';
import { updateStatusForm, getForm } from '../../api/forms';
import { Cookies } from 'react-cookie';

const ViewForm = () => {
    const params = useParams()
    const navigate = useNavigate()
    const cookie = new Cookies();
    const [isSuper, setIsSuper] = useState(cookie.get("isSuper"));
    const [loading, setLoading] = useState()
    const [formData, setFormData] = useState(null);

    useEffect(() => {
        getForm(params.id).then((result) => {
            console.log(result.data.response)
            setFormData(result.data.response)
        })
    }, [])

    const handleChange = (e) => {
        e.target.setCustomValidity("");
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const updateStatus = (is_reject) => {
        updateStatusForm(formData._id, formData.date, is_reject).then((result) => {
            setLoading(false)
            navigate(-1)
        })
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true)
        if (e.nativeEvent.submitter.name === "reject") {
            updateStatus(true)
        } else if (e.nativeEvent.submitter.name === "pending") {
            updateStatus(false)
        } else if (e.nativeEvent.submitter.name === "accept") {
            updateStatus(false)
        }
    };

    return (
        <div className="main-content">{(formData === null) ? <LoadingPage /> : <div className="add-brokers-guideline">
            <form onSubmit={handleSubmit}>
                <div className="form-group">
                    <label htmlFor="developer">Broker name</label>
                    <input
                        type="text"
                        id="broker_name"
                        name="broker_name"
                        value={formData.user_id.name}
                        disabled={true}
                        placeholder="Enter broker name"
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="developer">Broker phone</label>
                    <input
                        type="text"
                        id="broker_phone"
                        name="broker_phone"
                        value={formData.user_id.phone}
                        disabled={true}
                        placeholder="Enter broker phone"
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="developer">Created at</label>
                    <input
                        type="text"
                        id="broker_phone"
                        name="broker_phone"
                        value={formData.createdAt.split("T")[0]}
                        disabled={true}
                        placeholder="Enter broker phone"
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="developer">Developer</label>
                    <input
                        type="text"
                        id="developer"
                        name="developer"
                        value={formData.developer}
                        disabled={true}
                        placeholder="Enter developer"
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="client_name">Client name</label>
                    <input
                        type="text"
                        id="client_name"
                        name="client_name"
                        value={formData.client_name}
                        disabled={true}
                        placeholder="Enter client name"
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="developer">Client phone</label>
                    <input
                        type="text"
                        id="client_phone"
                        name="client_phone"
                        value={formData.client_phone}
                        disabled={true}
                        placeholder="Enter client phone"
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="developer">Client id</label>
                    <input
                        type="text"
                        id="client_id"
                        name="client_id"
                        value={formData.client_id}
                        disabled={true}
                        placeholder="Enter client id"
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="developer">Project name</label>
                    <input
                        type="text"
                        id="project_name"
                        name="project_name"
                        value={formData.project_name}
                        disabled={true}
                        placeholder="Enter project name"
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="developer">Sales name</label>
                    <input
                        type="text"
                        id="sales_name"
                        name="sales_name"
                        value={formData.sales_name}
                        disabled={true}
                        placeholder="Enter sales name"
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="developer">Sales phone</label>
                    <input
                        type="text"
                        id="sales_phone"
                        name="sales_phone"
                        value={formData.sales_phone}
                        disabled={true}
                        placeholder="Enter salse phone"
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="developer">Deal value</label>
                    <input
                        type="text"
                        id="deal_value"
                        name="deal_value"
                        value={formData.deal_value}
                        disabled={true}
                        placeholder="Enter deal value"
                    />
                </div>
                {(params.formType === "pending" || params.formType === "accept") && <div className="form-group">
                    <label htmlFor="developer">Upcoming earning</label>
                    <input
                        type={params.formType !== "accept" ? "number" : "text"}
                        id="date"
                        name="date"
                        value={formData.date}
                        onChange={handleChange}
                        placeholder="Enter upcoming earning"
                        disabled={params.formType !== "pending"}
                        onInvalid={(e) => e.target.setCustomValidity("Upcoming earning is required")}
                    />
                </div>}
                <div className="image-previews">
                    <div className="preview-item">
                        <img
                            src={`${proxy}/${formData.image}`}
                            alt={`Preview`}
                        />
                    </div>
                </div>

                {(params.formType === "new" && !isSuper) &&
                    <div style={{
                        width: "100%",
                        justifyContent: "center",
                        display: "flex"
                    }}>
                        <button
                            type="submit"
                            name="pending"
                            className="action-btn ban-btn"
                            style={{ width: "45%" }}
                        >
                            Pending
                        </button>
                    </div>}
                {isSuper && <>{(params.formType === "new" || params.formType === "pending") && <>{loading ? <div style={{
                    width: "100%",
                    justifyContent: "center",
                    display: "flex"
                }}>
                    <div className="spinner"></div>
                </div> : <div className="choices-container" style={{
                    display: "flex",
                    width: "100%",
                    gap: "15px", // Better than space-between for consistent spacing
                    flexWrap: "wrap",
                    marginTop: "10px",
                    justifyContent: "center"
                }}>
                    <button
                        type="submit"
                        name="reject"
                        className={`action-btn remove-btn`}
                        style={{ width: "45%" }}
                    >
                        Reject
                    </button>
                    {params.formType === "new" ? <button
                        type="submit"
                        name="pending"
                        className="action-btn ban-btn"
                        style={{ width: "45%" }}
                    >
                        Pending
                    </button> : <button
                        type="submit"
                        name="accept"
                        className="action-btn accept-btn"
                        style={{ width: "45%" }}
                    >
                        Accept
                    </button>}
                </div>}</>}</>}
            </form>
        </div>}</div>
    );
};

export default ViewForm;